<template>
<div class="gallery">
    <a v-for="(image, i) in images" :key="image.href" :href="image.href" target="_blank" class="gallery__image" :class="{'gallery__image_current': i == imageActiveIndex, 'gallery__image_prev': imageActiveIndex > 0 ? i == imageActiveIndex - 1 : i == images.length - 1}" @click.prevent="$emit('image-click', i)"><img :src="i == 0 ? image.large9x4 : image.medium9x4" alt="" /></a>
    <button class="btn btn-outline-shadow-secondary gallery__button d-none d-lg-block" @click="$emit('image-click', 0)">{{t.all_photos || 'View all'}}</button>
    <button v-if="videos.length > 0" class="btn btn-clean gallery__button d-lg-none" @click="$emit('video-click', 0)"><img src="/img/Buttons/play-video-small.svg" alt=""></button>
</div>
</template>

<script>
export default {
    data() {
        return {
            imageActiveIndex: 0
        };
    },
    methods: {
        
    },
    props: ['images','videos','t'],
    watch: {
        
    },
    mounted() {
        const maxIndex = this.images.length-1;
        setInterval(() => {
            if (this.imageActiveIndex < maxIndex) {
                this.imageActiveIndex++;
            } else {
                this.imageActiveIndex = 0;
            }
        }, 5000);

        swipedetect(this.$el, direction => {
            if (direction == 'left' || direction == 'right') {
                this.$emit('image-click', this.imageActiveIndex);
            }
        });
    }
}
</script>

<style>
    
</style>